module.exports = __webpack_public_path__ + "static/img/1.a1f1208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newThree/1.png
// module id = lVpo
// module chunks = 0